import { render, staticRenderFns } from "./link-expander.vue?vue&type=template&id=3a6f0355&scoped=true&"
import script from "./link-expander.vue?vue&type=script&lang=js&"
export * from "./link-expander.vue?vue&type=script&lang=js&"
import style0 from "./link-expander.vue?vue&type=style&index=0&id=3a6f0355&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6f0355",
  null
  
)

export default component.exports